import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ClusterOutlinedSvg from "@ant-design/icons-svg/es/asn/ClusterOutlined";
import AntdIcon from "../components/AntdIcon";
var ClusterOutlined = function ClusterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClusterOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ClusterOutlined.displayName = 'ClusterOutlined';
}
export default /*#__PURE__*/React.forwardRef(ClusterOutlined);